function normalizeNetworkName(value) {
  return String(value ?? "").trim().toLowerCase();
}

function networkNames(config, aliases = []) {
  return new Set(
    [
      config?.value,
      config?.label,
      config?.currencySymbol,
      config?.name,
      config?.EvmName,
      ...aliases,
    ]
      .map(normalizeNetworkName)
      .filter(Boolean),
  );
}

export function optionMatchesNetwork(option, config, aliases = []) {
  const acceptedNames = networkNames(config, aliases);
  return [option?.value, option?.label]
    .map(normalizeNetworkName)
    .filter(Boolean)
    .some((value) => acceptedNames.has(value));
}

export function resolveNftNetworkOption(
  option,
  networks,
  { bscAliases = [], ethereumAliases = [] } = {},
) {
  if (optionMatchesNetwork(option, networks?.BSC, bscAliases)) {
    return networks.BSC;
  }
  if (optionMatchesNetwork(option, networks?.ETH, ethereumAliases)) {
    return networks.ETH;
  }
  return null;
}

export function findSelectedNftNetworkOption(
  options,
  config,
  aliases = [],
) {
  return (
    (options || []).find((option) =>
      optionMatchesNetwork(option, config, aliases),
    ) || null
  );
}
